import { getValueCookie } from "../services/cookieService"

// Intercompany customers (2026-10-21, client's ask) — customers that are
// really one of our own companies, invoiced from the parent company at the
// agreed intercompany price instead of the normal price levels.
// 0016027 = Altitude as a customer inside Mayaland (CompanyId 3). Add more
// here if another child company is created.
const INTERCOMPANY_CUSTOMERS = {
    '3': ['0016027'],
}

// Same divisor SalesOrderV3.js's updateAltitudePrices() uses to price the
// Mayaland mirror of an Altitude order: Altitude cost = Mayaland cost / 0.95.
export const INTERCOMPANY_COST_DIVISOR = 0.95

export function isIntercompanyCustomer(customerNo, companyId = getValueCookie('CompanyId')) {
    const list = INTERCOMPANY_CUSTOMERS[String(companyId)] || []
    return list.includes(String(customerNo || '').trim())
}

// Agreed intercompany price for a given parent-company cost, rounded exactly
// like updateAltitudePrices() (toFixed(2)) so an untouched SO price matches it.
export function intercompanyPriceFromCost(cost) {
    if (cost === null || cost === undefined || cost === '') return null
    const n = Number(cost)
    if (Number.isNaN(n) || n <= 0) return null
    return Number((n / INTERCOMPANY_COST_DIVISOR).toFixed(2))
}
